
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invoice-template",
      function () {
        return require("private-next-pages/invoice-template.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invoice-template"])
      });
    }
  